module.exports = __webpack_public_path__ + "static/media/BR.5091e787.svg";